import { inject, Injectable } from '@angular/core'
import { PrivateMessagesService } from '../domain/privateMessages/private-messages.service'
import { AnnouncementsService } from '../domain/announcements/announcements.service'
import { Announcement } from '../../models/announcement'
import { Message } from '../../features/messaging/message'
import { PrivateMessage } from '../../models/privateMessage'
import { combineLatest, Observable } from 'rxjs'
import { map, shareReplay, tap } from 'rxjs/operators'
import { SmsMessage } from '../../models/smsMessage'
import { SmsService } from '../domain/sms/sms.service'
import { LazyModalService } from '../../features/LazyModal/LazyModalService'
import { ModalController } from '@ionic/angular'
import { MessagingPage } from '../../pages/messaging/messaging/messaging-page.component'

@Injectable({
  providedIn: 'root',
})
export class MessagesService extends LazyModalService<void> {
  private privateMessagesService = inject(PrivateMessagesService)
  private announcementsService = inject(AnnouncementsService)
  private smsService = inject(SmsService)
  protected modalCtrl: ModalController

  private TAG = 'MessagesService'

  constructor() {
    const modalCtrl = inject(ModalController)

    super(modalCtrl)

    this.modalCtrl = modalCtrl
  }

  async open() {
    console.log(`${this.TAG}#open`)
    return await this.modalCtrl.create({
      component: MessagingPage,
      cssClass: 'messaging',
      componentProps: {},
    })
  }

  getAnnouncementsForCurrentUser(): Observable<Announcement[]> {
    return this.announcementsService.getAnnouncementsForCurrentUser()
  }

  getCombinedUnreadMessagesCount() {
    console.log('getCombinedUnreadMessagesCount')
    return combineLatest([
      this.privateMessagesService.getUnreadCountForCurrentUser(),
      this.announcementsService.getUnreadCountForCurrentUser(),
      this.smsService.getUnreadCountForCurrentUser(),
    ]).pipe(
      map((counts) => {
        console.log('getCombined', counts)
        return counts.reduce((a, b) => a + b)
      }),
      tap((e) => console.log('getCombinedUnreadMessagesCount', e)),
      shareReplay({ bufferSize: 1, refCount: true }),
    )
  }

  async send(message: Message) {
    console.log(this.TAG, 'send', message)
    if (message instanceof Announcement) await this.announcementsService.send(message)
    if (message instanceof PrivateMessage) await this.privateMessagesService.send(message)
    if (message instanceof SmsMessage) await this.smsService.send(message)
  }
}
